import { useApi } from "@lending/lib/api";

function usePatchVehicleLoanApplicationQuery() {
  const $api = useApi();

  return $api.useMutation("patch", "/v2/lending/vehicle_loan_applications/{uuid}/");
}

export { usePatchVehicleLoanApplicationQuery };
